<template>
  <section class="new_css">
    <el-row class="new_header">
      <el-col v-if="buttonList.length > 0" :span="24" class="organizetoolbar" style="padding-bottom: 0px">
        <el-form :inline="true" ref="selectForm" :model="selectForm" class="select_form">
          <el-form-item label="证书人员:">
            <el-input v-model="selectForm.PersonName" placeholder="人员名称"></el-input>
          </el-form-item>
          <el-form-item label="证书名称:">
            <el-input v-model="selectForm.CertificateName" placeholder="证书名称"></el-input>
          </el-form-item>
          <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
        </el-form>
      </el-col>
    </el-row>
    <div class="calc-height">
      <el-table :data="users" highlight-current-row height="100%" @current-change="selectCurrentRow" @row-dblclick="handleShow" class="new_table">
        <el-table-column type="index" width="50"> </el-table-column>
        <!-- <el-table-column label="证书档案" prop="CertificateInfoId" show-overflow-tooltip> </el-table-column> -->
        <el-table-column label="证书名称" prop="CertificateName"></el-table-column>
        <el-table-column label="证书人员" prop="PersonName"></el-table-column>
        <el-table-column label="身份证号" prop="IDCard"></el-table-column>
        <el-table-column label="专业" prop="CertProfessionName"></el-table-column>
        <el-table-column label="补贴金额" prop="CertificateSubsidyAmount"></el-table-column>
        <el-table-column label="补贴方案类型" prop="StandardType">
          <template slot-scope="scope">{{ scope.row.StandardType == 1 ? '建造师' : '律师' }}</template></el-table-column>
      </el-table>
    </div>
    <!-- 分页器 -->
    <el-pagination align="center" @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize" layout="prev, pager, next, jumper,total"
 :page-count="total" :total="totaldata">
    </el-pagination>

    <el-dialog :title="operation ? '新增' : '编辑'" :visible.sync="SakaryVisible" v-model="SakaryVisible" :close-on-click-modal="false">
        <el-form :rules="SakaryRules" ref="SakaryForm" :model="SakaryForm" label-width="100px">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="姓名:" prop="PersonName">
                        <el-input type="text" :disabled="true" v-model="SakaryForm.PersonName">
                            <el-button slot="append" icon="el-icon-search" @click="chooseUser"></el-button>
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="身份证号:" prop="IDCard">
                        <el-input type="text" v-model="SakaryForm.IDCard" disabled> </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12" style="display:none;">
                    <el-form-item label="证书人员id:" prop="PersonId">
                        <el-input type="text" v-model="SakaryForm.PersonId"> </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12" style="display:none;">
                    <el-form-item label="id:" prop="Id">
                        <el-input type="text" v-model="SakaryForm.Id"> </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12" style="display:none;">
                    <el-form-item label="证书档案id:" prop="CertificateInfoId">
                        <el-input type="text" v-model="SakaryForm.CertificateInfoId"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="证书名称:" prop="CertificateName">
                        <el-input type="text" :disabled="true" v-model="SakaryForm.CertificateName">
                            <el-button slot="append" icon="el-icon-search" @click="chooseCandidate"></el-button>
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="专业:" prop="CertProfessionName">
                        <el-select v-model="SakaryForm.CertProfessionName" filterable placeholder="证书专业" @change="CertProfessionModel($event)" style="width: 100%">
                            <el-option v-for="item in CertProfessionLists" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="补贴方案类型:" prop="StandardType">
                        <el-select v-model="SakaryForm.StandardType" placeholder="补贴方案类型" style="width: 100%">
                            <el-option label="建造师" :value="1"></el-option>
                            <el-option label="律师" :value="2"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="补贴金额:" prop="CertificateSubsidyAmount">
                        <el-input type="money" v-model="SakaryForm.CertificateSubsidyAmount">
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row v-if="operation1">
                <el-col :span="24" style="text-align: center">
                    <el-button type="primary" v-on:click="onSubmit('SakaryForm')">提交</el-button>
                </el-col>
            </el-row>
        </el-form>
    </el-dialog>
    <el-dialog :visible.sync="addUserVisible" v-model="addUserVisible" width="75%" center append-to-body>
      <UserChoose :data="choosedusers" :all="true" :single="false" @callback="usercallFunction"></UserChoose>
    </el-dialog>

    <!-- 证书档案 -->
    <certificateListModal ref="certificateListModal" @callback="usercallFunctionDA"></certificateListModal>
  </section>
</template>
<script>
import util from "../../../util/date";
import * as validate from "../../../util/validate";
import UploadFiles from "../../components/UploadFiles";
import {
  GetCertificateByType,
  AddCertificatePersonSubsidySchedule,
  UpdateInfoCertificatePersonSubsidySchedule,
  GetCertificatePersonSubsidyScheduleInfo,
  GetCertificatePersonSubsidyScheduleInfoList,
} from "../../api/hr";
import { getButtonList } from "../../promissionRouter";
import UserChoose from "../../components/UserChoose";
import Toolbar from "../../components/newToolbar";
import certificateListModal from "../componentModals/certificateListModal"
export default {
  components: { Toolbar, UserChoose, UploadFiles ,certificateListModal},
  data() {
    return {
      loading: true,
      currentPage: 1, // 当前页码
      total: null, // 总条数
      totaldata: null,
      operation: false, // true:新增, false:编辑
      operation1: true,
      pageSize: 20, // 每页的数据条数
      page: 1,
      key: 0,
      keyCommitment:0,
      CertTypeLists: [],
      CertCategoryLists: [],
      CertProfessionLists: [],
      choosedusers: [],
      SavePlaceLists: [],
      SakaryVisible: false,
      addUserVisible: false,
      selectForm: {
        PersonName: null,
        CertificateName: null,
      },
      SakaryForm: {
        Id:"",
        CertificateInfoId: "",
        PersonId: "",
        CertProfessionId: "",
        CertificateSubsidyAmount: "",
        StandardType: "",
        PersonName:"",
        CertificateName:"",
        IDCard:"",
      },
      users: [],
      buttonList: [],
      SakaryRules: {
        PersonName:[
          { required: true, message: "请选择姓名", trigger:"blur"},
        ],
        CertificateName: [
          { required: true, message: "请选择证书名称", trigger: "blur" },
        ],
        CertProfessionName: [
          { required: true, message: "请选择证书专业", trigger: "blur" },
        ],
        StandardType: [
          { required: true, message: "请选择补贴方案类型", trigger: "blur" },
        ],
        CertificateSubsidyAmount: [
          { required: true, message: "请填写证书补贴金额", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this[item.Func].apply(this, item);
    },
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });
        return;
      }
      GetCertificateByType({ type: "证书专业" }).then((res) => {
        this.CertProfessionLists = res.data.response;
      });
      GetCertificatePersonSubsidyScheduleInfo({ id: row.Id }).then((res) => {
        console.log(res.data.response)
        this.SakaryForm = res.data.response;


        this.key += 1;
        this.keyCommitment += 1;
        this.SakaryVisible = true;
      });

      this.operation = false;
      this.operation1 = true;
    },
    chooseCandidate() {//关联证书档案
      this.$refs.certificateListModal.onShowDlg();
    },
    handleShow() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要查看的一行数据！",
          type: "error",
        });
        return;
      }
      GetCertificateByType({ type: "证书专业" }).then((res) => {
        this.CertProfessionLists = res.data.response;
      });
      GetCertificatePersonSubsidyScheduleInfo({ id: row.Id }).then((res) => {
        
        this.SakaryForm = res.data.response;

          this.key += 1;
          this.keyCommitment += 1;
        this.SakaryVisible = true;
      });

      this.operation = false;
      this.operation1 = false;
    },
    handleAdd() {
      (this.SakaryForm = {
        Id:"",
        CertificateInfoId: "",
        PersonId: "",
        CertProfessionId: "",
        CertificateSubsidyAmount: "",
        StandardType: "",
        PersonName:"",
        CertificateName:"",
        IDCard:"",
      }),
      GetCertificateByType({ type: "证书专业" }).then((res) => {
        this.CertProfessionLists = res.data.response;
      });
        this.key += 1;
        this.keyCommitment += 1;
      (this.operation = true), (this.SakaryVisible = true);
      this.operation1 = true;
    },
    usercallFunction(newdata) {
      if (newdata.length > 1) {
        this.$message({
          message: "不允许选择多人",
          type: "error",
        });
        return;
      }
      
      this.$api.GetCurrentUserInfo({ userId: newdata[0].Id }).then((res) => {
        console.log(res.data)
        this.SakaryForm.IDCard = res.data.response.IDCard;
        this.SakaryForm.PersonId = newdata[0].Id;
        this.SakaryForm.PersonName = newdata[0].UserNameClaim;
        this.addUserVisible = false;
      });

    
    },
    usercallFunctionDA(newdata) {//证书档案
      console.log(newdata)
      this.SakaryForm.CertificateInfoId=newdata.CertificateInfoId;
      this.SakaryForm.CertificateName=newdata.CertificateName;
      this.candidateMangentModal = false;
    },
    chooseUser() {
      this.addUserVisible = true;
    },
    //获取用户列表
    getData(isCurrent = true) {
      if (isCurrent) {
        this.page = 1;
      }

      let para = {
        page: this.page,
        size: this.pageSize,
        PersonName: this.selectForm.PersonName,
        CertificateName: this.selectForm.CertificateName,
      };
      GetCertificatePersonSubsidyScheduleInfoList(para).then((res) => {
        this.total = res.data.response.pageCount;
        this.totaldata = res.data.response.dataCount;
        this.users = res.data.response.data;
        this.loading = false;
      });
    },
    getButtonList2(routers) {
      let _this = this;
      routers.forEach((element) => {
        let path = this.$route.path.toLowerCase();
        if (element.path && element.path.toLowerCase() == path) {
          _this.buttonList = element.children;
          return;
        } else if (element.children) {
          _this.getButtonList(element.children);
        }
      });
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.page = val;
      this.getData(false);
    },
    CertProfessionModel(id) {
      let obj = {};
      obj = this.CertProfessionLists.find((item) => {
        //model就是上面的数据源
        return item.Name === id; //筛选出匹配数据
      });
      this.SakaryForm.CertProfessionId = obj.Id;
    },
    onSubmit(formName) {
      this.$confirm("确定要提交吗？", "提示", {}).then(() => {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let para = Object.assign({}, this.SakaryForm);
            console.log(para);
            if (this.operation) {
              //新增
              AddCertificatePersonSubsidySchedule(para).then((res) => {
                if (res.data.success) {
                  this.$message({
                    message: "添加成功",
                    type: "success",
                    duration: 5000,
                  });
                  this.SakaryVisible = false;
                  this.getData();
                } else {
                  this.$message({
                    message: "添加失败",
                    type: "error",
                    duration: 5000,
                  });
                }
              });
            } else {
              //修改
              UpdateInfoCertificatePersonSubsidySchedule(para).then((res) => {
                if (res.data.success) {
                  this.$message({
                    message: "修改成功",
                    type: "success",
                    duration: 5000,
                  });
                  this.SakaryVisible = false;
                  this.getData(false);
                } else {
                  this.$message({
                    message: "修改失败",
                    type: "error",
                    duration: 5000,
                  });
                }
              });
            }
          } else {
            this.$message({
              message: "请检查必填项",
              type: "error",
              duration: 5000,
            });
            return false;
          }
        });
      });
    },
    dealFiles(data) {
        console.log(data.backData);
        this.SakaryForm.FileArry = data.backData;
    },
    dealFilesCommitment(data) {
        this.SakaryForm.CommitmentFileArry = data.backData;
    },
  },
  mounted() {
    this.getData();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    let buttons = window.localStorage.buttList
      ? JSON.parse(window.localStorage.buttList)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers, buttons);
  },
};
</script>
<style scoped>
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}
.calc-height {
  height: calc(100vh - 300px) !important;
}
</style>

